var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-1.5 0q0-2.692-1.904-4.596T8 1.5 3.404 3.404 1.5 8t1.904 4.596T8 14.5t4.596-1.904T14.5 8M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 6a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1"
  })));
};
export default SvgInfo;